import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { GetLeftInfoResponseDTO } from "./models/LeftPanelInfo.response.dto";

export class GetLeftInfoApi {
  static getLeftInfo = async () => {
    const response = GbApiRequestService.get("userApiV2", {
      params: {
        requestType: "balanceAndStats",
      },
    });

    return await withSchemaValidation(response, GetLeftInfoResponseDTO);
  };
}
